import { createTheme } from '@material-ui/core/styles';

const defaultTheme = {
  palette: {
    primary: {
      main: '#5B65DC',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#8E8E8E',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#DC125B',
      light: '#d79f9a',
    },
    error: {
      main: '#dc1212',
      light: '#d79f9a',
    },
    success: {
      main: '#41C377',
      light: '#93c4a8',
    },
    info: {
      main: '#928BB7',
      light: '#FAF8FF',
      contrastText: '#484554',
    },
  },
  typography: {
    button: {
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 8,
  },
  colors: {
    navBg: '#3E3E44',
    navBgHover: '#4A494F',
    gray1: '#D9D9D9',
    gray2: '#E4E4E4',
    gray3: '#e7e7e7',
    gray4: '#818FA0',
    gray5: '#BDC5D0',
    grey: '#8E8E8E',
    grey2: '#000000',
    grey3: '#EBEBEB',
    grey4: '#DEDEDE',
    blue: '#2E48D3',
    blue2: '#122056',
    blue3: '#001899',
    blue4: '#1b71e6',
    blue5: '#1C35BC',
    green: '#41C377',
    darkGreen: '#0d9146',
    orange: '#EA7502',
    lightOrange: '#f3b16c',
    lightBlue: '#5B65DC',
    lightBlue2: '#6C7FDF',
    lightBlue3: '#4DC2FF',
    errorPink: '#e3d7d5',
    errorPinkLight: '#f2eceb',
    testing: '#4aa7f8',
    development: '#8a0101',
    darkError: '#dc1212',

    badge_green: '#29ac60',
    badge_dark_green: '#077336',
    badge_light_blue: '#0085ca',
    badge_light_grey: '#5e5e5e',
    badge_purple: '#5265c3',
    badge_orange: '#c86300',
    badge_gray: '#5e5e5e',
    badge_pink: '#c94fd7',
  },
  overrides: {
    MuiFormControl: {
      marginNormal: {
        marginTop: 8,
      },
    },
    MuiButton: {
      contained: {
        color: 'white !important',
      },
    },
  },
};
const theme = createTheme(defaultTheme);

export default theme;
